<template>
  <el-dialog
    :title="$t('common.map')"
    :visible.sync="viewMapInfo.showMap"
    width="80%"
    :before-close="closeMap"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
  >
    <div class="map-container">
      <div id="qqmapcontainer" style="width: 100%; height: 500px; background-color: antiquewhite;"></div>
    </div>
  </el-dialog>
</template>

<script>
import { loadTianditu } from '@/utils/tianditu'
import { storeToTianditu } from '@/utils/coordTransform'

const DEFAULT_LNG = 100.985
const DEFAULT_LAT = 36.72

export default {
  name: 'ViewMap',
  data() {
    return {
      viewMapInfo: {
        lat: '',
        lng: '',
        showMap: false,
        map: null,
        marker: null
      },
      storeCoord: 'GCJ02'
    }
  },
  methods: {
    open(param) {
      this.viewMapInfo.showMap = true
      const hasInput = param && param.lng && param.lat
      this.viewMapInfo.lng = hasInput ? parseFloat(param.lng) : DEFAULT_LNG
      this.viewMapInfo.lat = hasInput ? parseFloat(param.lat) : DEFAULT_LAT
      this.$nextTick(() => this.initMap(hasInput))
    },
    initMap(hasInput) {
      loadTianditu()
        .then(({ T, config }) => {
          this.storeCoord = config.STORE_COORD || 'GCJ02'
          const display = hasInput
            ? storeToTianditu(this.viewMapInfo.lng, this.viewMapInfo.lat, this.storeCoord)
            : { lng: this.viewMapInfo.lng, lat: this.viewMapInfo.lat }

          const dom = document.getElementById('qqmapcontainer')
          if (!dom) return
          const map = new T.Map(dom)
          map.centerAndZoom(new T.LngLat(display.lng, display.lat), 17)
          map.addControl(new T.Control.Zoom())
          map.addControl(new T.Control.Scale())

          const icon = new T.Icon({
            iconUrl: '/img/maper.png',
            iconSize: new T.Point(25, 35),
            iconAnchor: new T.Point(12, 35)
          })
          const marker = new T.Marker(new T.LngLat(display.lng, display.lat), { icon })
          map.addOverLay(marker)

          this.viewMapInfo.map = map
          this.viewMapInfo.marker = marker
        })
        .catch(err => {
          this.$message && this.$message.error(err.message || '地图加载失败')
        })
    },
    closeMap() {
      this.viewMapInfo.showMap = false
      if (this.viewMapInfo.marker && this.viewMapInfo.map) {
        try {
          this.viewMapInfo.map.removeOverLay(this.viewMapInfo.marker)
        } catch (e) {
          // ignore
        }
      }
      this.viewMapInfo.marker = null
      this.viewMapInfo.map = null
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 500px;
}
</style>
